import React, { useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { MessageSquareIcon, MailIcon, ClockIcon } from 'lucide-react';
export const LiveChatSupport = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-7143">
      <Navbar scrolled={scrolled} data-id="element-7144" />
      <main className="pt-24 pb-20" data-id="element-7145">
        <div className="container mx-auto px-4 md:px-6" data-id="element-7146">
          <div className="max-w-3xl mx-auto bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm" data-id="element-7147">
            <div className="flex flex-col items-center text-center mb-8" data-id="element-7148">
              <div className="w-16 h-16 bg-[#2DB489]/10 rounded-full flex items-center justify-center mb-4" data-id="element-7149">
                <MessageSquareIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-7150" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7151">
                Live Chat
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD]" data-id="element-7152">
                Live chat support coming soon.
              </p>
              <p className="mt-4 text-gray-600 dark:text-[#B0C1BD]" data-id="element-7153">
                For now, please email us at{' '}
                <a href="mailto:support@yourdomain.com" className="text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-7154">
                  support@yourdomain.com
                </a>
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-7155">
              <div className="bg-gray-50 dark:bg-[#1A3330] rounded-lg p-6" data-id="element-7156">
                <div className="flex items-center mb-4" data-id="element-7157">
                  <ClockIcon className="h-5 w-5 text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7158" />
                  <h2 className="text-lg font-semibold text-gray-800 dark:text-[#F8FAF9]" data-id="element-7159">
                    Coming Q2 2023
                  </h2>
                </div>
                <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-7160">
                  We're working hard to bring you real-time chat support. Stay
                  tuned for updates!
                </p>
              </div>
              <div className="bg-gray-50 dark:bg-[#1A3330] rounded-lg p-6" data-id="element-7161">
                <div className="flex items-center mb-4" data-id="element-7162">
                  <MailIcon className="h-5 w-5 text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7163" />
                  <h2 className="text-lg font-semibold text-gray-800 dark:text-[#F8FAF9]" data-id="element-7164">
                    Email Support
                  </h2>
                </div>
                <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-7165">
                  In the meantime, our email support team is ready to help with
                  any questions or issues.
                </p>
                <a href="/support/email" className="inline-block mt-4 text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-7166">
                  Contact via Email →
                </a>
              </div>
            </div>
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-lg p-6 text-white" data-id="element-7167">
              <h2 className="text-xl font-semibold mb-3" data-id="element-7168">Get Notified</h2>
              <p className="mb-4 opacity-90" data-id="element-7169">
                Want to know when live chat support is available? Leave your
                email and we'll let you know.
              </p>
              <div className="flex flex-col sm:flex-row gap-2" data-id="element-7170">
                <input type="email" placeholder="Your email address" className="flex-grow px-4 py-2 rounded-lg border-2 border-white/30 bg-transparent text-white placeholder-white/70 focus:outline-none focus:border-white" data-id="element-7171" />
                <button className="bg-white text-[#2DB489] px-4 py-2 rounded-lg font-medium hover:bg-white/90 transition-colors" data-id="element-7172">
                  Notify Me
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-7173" />
    </div>;
};